import React from 'react';
import LogoutComponent from '../../../components/logout-page';

const Logout = (props) => (
  <LogoutComponent open {...props}/>
);

export default Logout; 
